import React, { Component, useContext } from 'react';
// import logo from '../assets/mb-logo.png';
// import logo1MIN from '../assets/mb_login_image_1_min.jpg';
import logo from '../assets/mb-logono plus.png';
import logo2MIN from '../assets/mb_login_image_2_min.jpg';
import logo3MIN from '../assets/mb_login_image_3_min.jpg';
import { axiosFinal } from '../plugins/axios';
import { USER, Roles ,allowedUsers } from '../constants/insurance/constant';
import auth from '../auth/auth';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import CloseIcon from '@mui/icons-material/Close';
import { cleverTap } from '../services/provider/common';
import { CLEVER_TAP_EVENTS, SESSION_STORAGE_KEYS } from '../constants/provider/constant';
import { toast } from "react-toast";
import { Box, Button, Modal, Typography } from '@mui/material';
import '../style/otpVerificationScreen.css'
import { locationServiceMap, validServices } from './common';
import {EVENTS} from '../event-constant'
import {logEventToAnalyticsPlatform,fetchUserDetailsAndSetUserForAnalytics } from '../helper/events'
import {API } from "../API_CONFIG";
import UserFeaturesContext  from  "../hook/UserDetails/UserFeaturesContext";
import { returnRoleBasedOnRoleId } from '../helper/utils';
import { generateToken } from '../components/vision/apiCalls';
import { syncDataToServiceWorker, unregister } from '../serviceWorkerRegistration';
import { getSpecialityList } from '../components/DoctorMangement/Helper/API';
const BASE_URL = API;

class SignUp extends Component {
  constructor(props) {
    super(props);
    this.otpFieldsRef = [];
    this.state = {
      items: [
        { img: logo2MIN },
        { img: logo3MIN }
      ],
      errors: {
        email: true
      },
      showMessage: null,
      showLoginDisabled: true,
      showForgotDialogBox: false,
      accessToken: props.match.params.token ? props.match.params.token : null,
      id: props.match.params.id ? props.match.params.id : null,
      tokenExpired: false,
      otp: '',
      userId: '',
      userEmail: null,
      isWrongOTP: false,
      errorMessage: null,
      isSubmitting: false,
      showOTPScreen: false,
      encryptionToken: null,
      otpValues: ['', '', '', '', '']
    }
  }

  componentDidMount(){
    unregister();
    if(localStorage.getItem("tokenExpired")){
      toast.error("Session is expired, Login again to continue")
      localStorage.removeItem("tokenExpired");
      localStorage.getItem("access_token") ?? localStorage.removeItem("access_token");
    }
    if(this.state.accessToken) {
      localStorage.clear();
      this.login();
    }
    cleverTap(CLEVER_TAP_EVENTS.loginVisited, { srcPage: "Login Page" })
  }

  setStateCredentials(emailValue) {
    this.setState({
      ...this.state,
      errors: {
        email: emailValue,
      },
      showLoginDisabled: false
    })
  }

  checkCredentials = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const userName = event.target.value
    this.setState({ userName: userName });
    var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
    if (!pattern.test(event.target.value)) {
      this.setStateCredentials(false);
    } else {
      this.setStateCredentials(true);
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    this.login(data)
  };

  returnRole(roleId) {
   return returnRoleBasedOnRoleId(roleId);
  }

  checkRoleId(users) {
    let role = this.returnRole(users.roleId);
    if (role == null && users.rolesFeatures && users.rolesFeatures.roles) {
      users.rolesFeatures.roles.forEach(elem => {
        if (this.returnRole(elem.roleId) != null && role == null) {
          role = this.returnRole(elem.roleId);
        }
      })
      return role;
    } else {
      return role;
    }
  }

  closeOTPModal = () => {
    this.setState({
      otp: '',
      isWrongOTP: false,
      errorMessage: null,
      isSubmitting: false,
      showOTPScreen: false,
      otpValues: ['', '', '', '', '']
    });
  }

  handleOTPChange = (index, value) => {
    // validations
    const numericPattern = /^[0-9]*$/;
    if (value.length > 1 || !numericPattern.test(value)) {
      return;
    }

    if (this.state.isWrongOTP) {
      this.setState({
        isWrongOTP: false,
        errorMessage: null
      });
    }

    const newOtpValues = [...this.state.otpValues];
    newOtpValues[index] = value.split(" ").join("");

    this.setState({
      otp: newOtpValues.join(''),
      otpValues: newOtpValues
    });

    if (value.length === 1 && index < this.state.otpValues.length - 1) {
      this.otpFieldsRef[index + 1].focus();
    }
  };

  handleBackspace = (index) => {
    if(this.state.isWrongOTP) {
      this.setState({
        isWrongOTP: false,
        errorMessage: null
      });
    }

    if (this.state.otpValues[index] !== '') {
      const newOtpValues = [...this.state.otpValues];
      newOtpValues[index] = '';

      this.setState({
        otp: newOtpValues.join(''),
        otpValues: newOtpValues
      });

    } else if (index > 0) {
      this.otpFieldsRef[index - 1].focus();
    }
  };


  login(data){
    const that = this;
    let roleName = null;
    let authenticateAPIRequestBody;
    let url = BASE_URL.providerNode + '/';

    let route = url + 'provider/Authenticate';
    cleverTap(CLEVER_TAP_EVENTS.loginAttempted, {
      srcPage: "/login"
    });

    if (data) {
      authenticateAPIRequestBody = {
        userName: data.get('email').trim(),
        applicationId: this.checkInsurer() ? 100051 : 10007,
        password: data.get('password')
      };
    } else {
      if (this.state.accessToken) {
        authenticateAPIRequestBody = {
          accessToken: this.state.accessToken,
          fromOldPortal: true,
          providerId: this.state.id,
        };
      }
    }

    axiosFinal.post(route, authenticateAPIRequestBody)
      .then(function (response) {
        if (response.data?.isAuthenticated) {
          logEventToAnalyticsPlatform({
            name: EVENTS.PC_LOGIN_INITIATE.name,
            payload: {
              screenName: EVENTS.PC_LOGIN_INITIATE.screen_name,
              username: data?.get('email'),   //this send username of the user not email id        
            },
            schema: EVENTS.PC_LOGIN_INITIATE.schema,
          });
          if(response.data.isOtpNeeded === undefined){
            throw new Error();
          } else if(response.data.isOtpNeeded) {
            if(!response.data.isSuccess) {
              throw new Error();
            }

            that.setState({
              showOTPScreen: true,
              userId: data ? data.get('email').trim() : '',
              // userDetails: response.data?.userDetails ? response.data.userDetails : null,
              encryptionToken: response.data?.accessToken ? response.data.accessToken : '',
              userEmail: response.data?.otpSentOn ? response.data.otpSentOn : 'Registered EmailId'
            });
          } else if(!response.data.isOtpNeeded) {
            toast.success("Logged in Successfully.")
            that.setState({
              showMessage: null
            }, () => {
              auth.login(async () => {
                let user_details = response.data.userDetails;
                let hosp_details = response.data.hospDetails;
                roleName = that.checkRoleId(user_details);
                user_details.roleId = Roles[roleName];
                user_details.entityName = hosp_details?.hospName || user_details.firstName + ", " + user_details.lastName;
                USER.user = user_details;
                localStorage.setItem("roleName", roleName);
                localStorage.setItem("user_details", JSON.stringify(user_details));
                localStorage.setItem("access_token", JSON.stringify(response.data.accessToken));
                localStorage.setItem("userFeatures", response.data.userFeatureHash);
                localStorage.setItem("hosp_address", hosp_details?.address);
                
                if(response.data.allowPushNotifications !== undefined) {
                  localStorage.setItem('allowPushNotifications', response.data.allowPushNotifications);
                }
                if(response.data.refreshRate) {
                  localStorage.setItem('refreshRate', response.data.refreshRate);
                }
                
                syncDataToServiceWorker();
                
                let location;
                validServices().then(function (response) {
                  localStorage.setItem("ValidServices", JSON.stringify(response.data.validServices))
                  if(response.data.validServices.includes("VISION")) {
                    generateToken();
                  }
                  localStorage.setItem("serviceSelected", response.data.validServices[0])
                  location = locationServiceMap(roleName, response.data.validServices[0]);
                  that.props.history.push(location);
                }).catch(function(error) {
                  console.log(error);
                  localStorage.setItem("serviceSelected", "LABS")
                  location = locationServiceMap(roleName, "LABS");
                  that.props.history.push(location);
                });

             const specialityMap = {};
             const specialityArray = await getSpecialityList();
                if (specialityArray) {
                  specialityArray.specialitiesList.map((item) => {
                    specialityMap[item.specialityId] = item.title;
                  })
                }
                localStorage.setItem(SESSION_STORAGE_KEYS.SPECIALITY_ARRAY, JSON.stringify(specialityMap));

                cleverTap(CLEVER_TAP_EVENTS.loginSuccess,{
                  ProviderId: user_details.providerId,
                  platform: "web",
                  Message: "Success",
                  isSuccess: 1
                });
                window.clevertap.profile.push(user_details);
              });
            })
          }

        } else if (!response.data?.isAuthenticated) {
          cleverTap(CLEVER_TAP_EVENTS.loginFailed, {
            isSuccess: 0,
            srcPage: "Login",
            srcType: "Web/mWeb",
            ErrorMessage: "You don't have access to Login",
            failureReason: "Login failed",
          });
          toast.error(`Authentification Failed: ${response && response.data && response.data.errorMessage ? response.data.errorMessage.replaceAll("_", " ") : "You don't have access to Login"}`)
        } else {
          toast.error("Unable to login");
          cleverTap(CLEVER_TAP_EVENTS.loginFailed, {
            srcType: "Web/mWeb",
            ErrorMessage: "You don't have access to Login",
            srcPage: "Login",
            isSuccess: 0,
            failureReason: "Login failed",
          });
        }
      }).catch(function (error) {
        toast.error("Unable to login");
        cleverTap(CLEVER_TAP_EVENTS.loginFailed, {
          isSuccess: 0,
          srcPage: "Login",
          srcType: "Web/mWeb",
          ErrorMessage: "Failure in Authenticate Api",
          failureReason: "Login failed",
        });
      });
  }

  carouselBg() {
    return (
      <Carousel
        autoPlay={true}
        interval={5000}
        showIndicators={true}
        showArrows={true}
        transitionTime={2000}
        infiniteLoop={true}
        autoFocus={false}
        showThumbs={false}
        stopOnHover={false}
      >
        {
          this.state.items.map((item, i) => (
            <div key={i} className="flex justify-center w-full">
              <img className="rounded w-full" src={item.img} alt="logo of provider"></img>
            </div>
          ))
        }
      </Carousel>
    )
  }

  checkInsurer = () => {
    return ['ins-stage.medibuddy.in', 'ins.medibuddy.in'].includes(window.location.host)
  }

  verifyOTP = (saveUserFeatures) => {
    const that = this;
    that.setState({
      isSubmitting: true
    });

    let roleName = null;
    let url = BASE_URL.providerNode + '/';

    let route = url + 'provider/verifyOTP';
    cleverTap(CLEVER_TAP_EVENTS.otpVerificaiton, {
      srcPage: "/login"
    });

    const verifyOTPAPIRequestBody = {
      otp: that.state.otp,
      applicationId: this.checkInsurer() ? 100051 : 10007,
      userId: that.state.userId,
      encryptedToken: that.state.encryptionToken,
    };

    axiosFinal.post(route, verifyOTPAPIRequestBody)
      .then(function (response) {
        if (response.data?.success) {
          that.setState({
            isSubmitting: false,
            showOTPScreen: false,
          });
          toast.success("Logged in Successfully.");

          that.setState({
            showMessage: null
          }, () => {
            auth.login(async () => {
              let user_details = response.data.userDetails;
              let hosp_details = response.data.hospDetails;
              roleName = that.checkRoleId(user_details);
              user_details.roleId = Roles[roleName];
              user_details.entityName = hosp_details?.hospName || user_details.firstName + ", " + user_details.lastName;

              USER.user = user_details;
              localStorage.setItem("roleName", roleName);
              localStorage.setItem("user_details", JSON.stringify(user_details));
              localStorage.setItem("access_token", JSON.stringify(response.data.accessToken));
              localStorage.setItem("erIDs", JSON.stringify(response.data.userDetails.corporateIDs));
              localStorage.setItem("userName", response.data.userDetails.userName);
              localStorage.setItem("userFeatures", response.data.userFeatureHash);
              localStorage.setItem("hosp_address", hosp_details?.address);
              localStorage.setItem("isOtpEnabledAttendanceProvider", response?.data?.isOtpEnabledAttendanceProvider);

              if(response.data.allowPushNotifications !== undefined) {
                localStorage.setItem('allowPushNotifications', response.data.allowPushNotifications);
              }
              if(response.data.refreshRate) {
                localStorage.setItem('refreshRate', response.data.refreshRate);
              }
              syncDataToServiceWorker();

              const userFeatures = user_details?.rolesFeatures?.features?.map((item) => {
                return item.featureName;
              });

              let location;
              await fetchUserDetailsAndSetUserForAnalytics();
              logEventToAnalyticsPlatform({
                name: EVENTS.PC_LOGIN_SUCCESS.name,
                payload:{
                  screenName:EVENTS.PC_LOGIN_SUCCESS.screen_name,
                  username:user_details.userName,
                  provider_id: '' + (user_details.providerId ||  user_details.parentId),
                  provider_name: user_details.entityName,
                },
                schema: EVENTS.PC_LOGIN_SUCCESS.schema,
              })
              validServices().then(function (response) {
                localStorage.setItem("ValidServices", JSON.stringify(response.data.validServices))
                if(response.data.validServices.includes("VISION")) {
                  generateToken();
                }
                localStorage.setItem("serviceSelected", response.data.validServices[0])
                location = locationServiceMap(roleName, response.data.validServices[0]);
                that.props.history.push(location);
              }).catch(function(error) {
                console.log(error);
                localStorage.setItem("serviceSelected", "LABS")
                // Get username from localStorage
                const username = localStorage.getItem("userName");
                if(allowedUsers.includes(username))
                {
                  location = roleName == "insureragent" ? "/"+roleName+"/appointments/esalesqueue" : "/"+roleName+"/charts";
                }
                else{
                  location = roleName == "insureragent" ? "/"+roleName+"/appointments/esalesqueue" : "/"+roleName+"/appointments";
                }
                that.props.history.push(location);
              });

              const specialityMap = {};
             const specialityArray = await getSpecialityList();
                if (specialityArray) {
                  specialityArray.specialitiesList.map((item) => {
                    specialityMap[item.specialityId] = item.title;
                  })
                }
                
              localStorage.setItem(SESSION_STORAGE_KEYS.SPECIALITY_ARRAY, JSON.stringify(specialityMap));
              saveUserFeatures(userFeatures || [], user_details?.rolesFeatures?.roles || []);

              cleverTap(CLEVER_TAP_EVENTS.loginSuccess,{
                ProviderId: user_details.providerId,
                platform: "web",
                Message: "Success",
                isSuccess: 1
              });
              window.clevertap.profile.push(user_details);
            });
          })
        } else{
          that.setState({
            isWrongOTP: true,
            isSubmitting: false,
            errorMessage: 'Something went wrong please try again'
          });
          toast.error("Unable to login");
          cleverTap(CLEVER_TAP_EVENTS.loginFailed, {
            srcType: "Web/mWeb",
            ErrorMessage: "You don't have access to Login",
            srcPage: "Login",
            isSuccess: 0,
            failureReason: "Login failed",
          });
        }
      })
      .catch(function (error) {
        error?.response?.data?.error ?
          toast.error("Authentification Failed") :
          toast.error("Unable to login");

        that.setState({
          isWrongOTP: true,
          isSubmitting: false,
          errorMessage: error?.response?.data?.error ?
            (error.response.data.error).replace(/_/g, ' ') :
            'Something went wrong please try again!'
        });

        cleverTap(CLEVER_TAP_EVENTS.loginFailed, {
          srcPage: "Login-OTP-Verification",
          srcType: "Web/mWeb",
          ErrorMessage: error?.response?.data?.error  ? 
            error.response.data.error :
            "Failure in verify otp api",
          failureReason: error?.response
        });
      });
  }

  render() {
    if (localStorage.getItem('access_token')) {
      localStorage.getItem("roleName") == "insureragent" ?
        this.props.history.push("/insureragent/appointments/esalesqueue")
        : this.props.history.push(locationServiceMap(localStorage.getItem("roleName"), localStorage.getItem("serviceSelected")))
    }
    // login-back bg-no-repeat bg-cover bg-right
    return (
      <UserFeaturesContext.Consumer>
        {({ userFeatures, saveUserFeatures }) => (
          <div className="flex justify-center space-x-0 md:space-x-0 bg-gradient-to-l from-gray-900 via-red-900 to-gray-900">
            <div className="invisible w-0 md:visible md:w-6/12 lg:w-8/12  block m-auto ml-14 white-shadow sm:my-15 ml-0">
              {this.carouselBg()}
            </div>

        <div className="w-full md:w-6/12 lg:w-4/12">
          <div className="flex flex-col h-screen">
            <div className="grid place-items-center my-10 lg:pl-10 sm:my-15 mr-14 my-auto">

              <div className="w-11/12 sm:w-11/12 p-10 md:w-6/12 lg:w-11/12 :w-4/12 px-6 py-10 sm:px-10 sm:py-6 bg-white rounded-lg shadow-md lg:shadow-lg">
                <div className="flex">
                  <div className="w-15-per my-auto">
                    <img src={logo} alt="logo of provider"></img>
                  </div>
                  <div className="text-lg font-semibold pl-2">
                    <span className="text-mb-blue">Medi</span>
                    <span className="text-mb-red">Buddy</span>
                    <br></br>
                    {
                      !this.checkInsurer() ?
                        <React.Fragment>
                          <span className="text-mb-red">Provider</span>
                          <span className="text-mb-blue">Central</span>
                        </React.Fragment>
                        :
                        <React.Fragment>
                          <span className="text-mb-red">Insur</span>
                          <span className="text-mb-blue">ance</span>
                        </React.Fragment>
                    }
                  </div>
                </div>

                <form className="mt-10" method="POST" onSubmit={(e) => this.handleSubmit(e)}>
                  <label htmlFor="email" className="block text-xs font-semibold text-gray-600 uppercase">Username</label>
                  <input
                    id="email"
                    type="text"
                    name="email"
                    placeholder="username"
                    autoComplete="text"
                    onChange={(e) => { this.checkCredentials(e);}}
                    className="block w-full py-3 px-1 mt-2 
                    text-gray-800 appearance-none 
                    border-b-2 border-gray-100
                    focus:text-gray-500 focus:outline-none focus:border-gray-200"
                    required
                  />

                  <label htmlFor="password" className="block mt-2 text-xs font-semibold text-gray-600 uppercase">Password</label>
                  <input
                    id="password"
                    type="password"
                    name="password"
                    placeholder="password"
                    autoComplete="current-password"
                    className="block w-full py-3 px-1 mt-2 mb-4
                    text-gray-800 appearance-none 
                    border-b-2 border-gray-100
                    focus:text-gray-500 focus:outline-none focus:border-gray-200"
                    required
                  />

                  <button
                    className={"w-full py-3 mt-2 bg-mb-btn-color rounded-sm font-medium text-white uppercase cursor-pointer  focus:outline-none hover:bg-gray-700 hover:shadow-none " + (this.state.showLoginDisabled ? 'text-white opacity-50 cursor-not-allowed' : 'text-white opacity-100 cursor-pointer')}
                    disabled={this.state.showLoginDisabled}
                  >
                    Login
                  </button>

                  {/* verify otp popup screen */}
                  <Modal
                    open={this.state.showOTPScreen}
                    onClose={null}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box sx={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      width: 'auto',
                      bgcolor: 'background.paper',
                      border: '1px solid #000',
                      borderRadius: '20px',
                      boxShadow: 24,
                      p: 4,
                    }}>
                      <div
                        style = {{
                          display: 'flex',
                          justifyContent: 'space-between'
                        }}
                      >
                        <Typography id="modal-modal-title">
                          <span style={{color: '#828282', fontFamily: 'Lexend Deca'}}>Enter: </span> 
                          <span style={{fontWeight: '700', fontFamily: 'Lexend Deca'}}>{this.state.otpValues.length} digit OTP</span>
                        </Typography>
                        <div className="text-gray-500" onClick={this.closeOTPModal}>
                          <span className="cursor-pointer">
                            <CloseIcon></CloseIcon>
                          </span>
                        </div>
                      </div>

                      <div>
                        <Typography id="modal-modal-title">
                          <span style={{color: '#828282', fontFamily: 'Lexend Deca'}}>Sent on: </span> 
                          <span style={{fontWeight: '700', fontFamily: 'Lexend Deca'}}>{this.state.userEmail}</span>
                        </Typography>
                      </div>

                      <div className="otp-container">
                        {
                          this.state.otpValues.map((value, index) => (
                            <input
                              key={index}
                              type="tel"
                              maxLength="1"
                              className={ this.state.isWrongOTP ? "wrongOTP" : "otp-input" }
                              value={value}
                              // pattern="[1-9]{5}"
                              onChange={(e) => this.handleOTPChange(index, e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === 'Backspace') {
                                  this.handleBackspace(index);
                                }
                              }}
                              ref={(ref) => {
                                this.otpFieldsRef[index] = ref;
                              }}
                            />
                          ))
                        }
                      </div>
                      {
                        this.state.errorMessage ?
                          <span
                            style={{
                              fontSize: '12px',
                              color: 'red',
                              fontFamily: 'Lexend Deca'
                            }}
                          >
                          { this.state.errorMessage }
                          </span> : null
                      }

                      <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        <span
                          style = {{ 
                            color: '#828282',
                            fontSize: '14px',
                            fontFamily: 'Lexend Deca'
                          }}
                        >
                          The OTP has been shared on your Email ID.<br></br>
                          Please enter the OTP to proceed.
                        </span>
                      </Typography>

                      <Button
                        style={{
                          height: '48px',
                          marginTop: '20px',
                          borderRadius: '16px',
                          backgroundColor:
                            this.state.otp.length !== this.state.otpValues.length ||
                              this.state.isWrongOTP ||
                              this.state.isSubmitting ?
                              '#00000042' : '#1778f2',
                        }}
                        onClick={(e)=>{ e.preventDefault(); e.stopPropagation(); this.verifyOTP(saveUserFeatures)}}
                        className={"w-full py-3 mt-2 bg-mb-btn-color rounded-sm font-medium text-white uppercase cursor-pointer  focus:outline-none hover:bg-gray-700 hover:shadow-none " + (this.state.showLoginDisabled ? 'text-white opacity-50 cursor-not-allowed' : 'text-white opacity-100 cursor-pointer')}
                        disabled={
                          this.state.otp.length !== this.state.otpValues.length ||
                            this.state.isWrongOTP ||
                            this.state.isSubmitting ?
                            true : false
                        }
                      >
                        <span
                          style={{
                            fontFamily: 'Lexend Deca',
                            color: '#fff',
                            fontWeight: '400',
                            fontSize: '14px',
                          }}
                        >
                          {(this.state.isSubmitting) ? "Verifying..." : "Verify OTP"}
                        </span>
                      </Button>
                    </Box>
                  </Modal>

                        <div className="text-center pt-2">
                          <span className="text-mb-blue text-xs font-semibold cursor-pointer" onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.props.history.push("/forgotPassword") }}>Forgot Password ?</span>
                        </div>

                  <div className="text-center pt-5">
                    <p className="text-red-500 text-xs italic">{this.state.showMessage}</p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>


          </div>
        )}
      </UserFeaturesContext.Consumer>
    );
  }
}

export default SignUp;
